import { z } from "zod";

const stringArr = z.array(z.string());

const ExplainerSchema = z.object({
  source: stringArr,
  function: stringArr,
  utility: stringArr,
  effect: stringArr,
  group: stringArr,
});

const SkinMatchIngredientInfoSchema = z.object({
  inci_name: z.string(),
  inci_id: z.string(),
  chemical_name: z.string(),
  inci_name_readable: z.string(),
  explainer: ExplainerSchema,
});

const status = z.union([z.literal("404"), z.literal("400"), z.literal("500")]);

const SkinMatchIngredientsFailureSchema = z.object({
  status,
  reason: z.string(),
});

const SkinMatchIngredientsData = z.array(SkinMatchIngredientInfoSchema);

const SkinMatchResponseSchema = z.union([
  SkinMatchIngredientsFailureSchema,
  SkinMatchIngredientsData,
]);
type SkinMatchApiResponse = z.infer<typeof SkinMatchResponseSchema>;
type SkinMatchIngredientData = z.infer<typeof SkinMatchIngredientsData>;
type SkinMatchIngredientInfo = z.infer<typeof SkinMatchIngredientInfoSchema>;
type ExplainerType = z.infer<typeof ExplainerSchema>;

export { SkinMatchResponseSchema };
export type {
  SkinMatchApiResponse,
  SkinMatchIngredientData,
  SkinMatchIngredientInfo,
  ExplainerType,
};
